import StartRating from "components/StartRating/StartRating";
import React, { FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import { RootState } from "store";
import { useSelector, useDispatch } from "react-redux";
import { getTransaction } from "actions/orderActions";
import { ITransaction } from "types/interfaces";
import moment from "moment";
import formatRupiah from "utils/toRupiah";
import { secondToHour } from "utils/timeConvert";
export interface PayPageProps {
  match?: any;
}

interface ICountDown {
  hour: number;
  minute: number;
  second: number;
}

const PayPage: FC<PayPageProps> = ({ match }) => {
  const dispatch = useDispatch();

  const { transaction }: { transaction: ITransaction } = useSelector(
    (state: RootState) => state.orderSingle
  );

  const [countDown, setCountDown] = useState<number>(
    5400 -
      moment().diff(moment(transaction.transaction.createdAt), "seconds") || 0
  );

  // eslint-disable-next-line
  const [count, setCount] = useState<ICountDown>({
    hour: 1,
    minute: 30,
    second: 0,
  });

  useEffect(() => {
    dispatch(getTransaction(match.params.id));
  }, [match.params.id]);

  useEffect(() => {
    setTimeout(() => {
      setCountDown(
        5400 -
          moment().diff(moment(transaction.transaction.createdAt), "seconds")
      );
    }, 1000);
  }, [countDown]);

  // useEffect(() => {
  //   dispatch(getSingleProduct(ongoingOrder.productId));
  // }, [ongoingOrder]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (!count.second) {
  //       if (!count.minute) {
  //         if (!count.hour) {
  //           return setCount({ hour: 0, minute: 0, second: 0 });
  //         }
  //         return setCount({ hour: count.hour - 1, minute: 59, second: 59 });
  //       }
  //       return setCount({
  //         hour: count.hour,
  //         minute: count.minute - 1,
  //         second: 59,
  //       });
  //     }
  //     return setCount({ ...count, second: count.second - 1 });
  //   }, 1000);
  // }, [count]);

  const renderContent = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-3xl lg:text-4xl font-semibold">Selamat 🎉</h2>

        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="space-y-6">
          <h3 className="text-2xl font-semibold">Booking Anda</h3>
          <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="flex-shrink-0 w-full sm:w-40">
              <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
                <NcImage src={transaction.product.images[0] || "/avatar.png"} />
              </div>
            </div>
            <div className="pt-5  sm:pb-5 sm:px-5 space-y-3">
              <div>
                <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1">
                  {/* Categorynya */}
                  {transaction.profile.displayName || ""}
                </span>
                <span className="text-base sm:text-lg font-medium mt-1 block">
                  {/* Nama Barang */}
                  {transaction.product.name || ""}
                </span>
              </div>
              <div className="w-10 border-b border-neutral-200  dark:border-neutral-700"></div>
              <StartRating
                reviewCount={transaction.productStatus.reviews.length || 0}
                point={transaction.productStatus.rating || 0}
              />
            </div>
          </div>
          <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
            <div className="flex-1 flex-col p-5 space-y-4">
              <div className="flex items-center space-x-4">
                <svg
                  className="w-8 h-8 text-neutral-300 dark:text-neutral-6000"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 5.07987C14.8551 4.11105 16.1062 3.5 17.5 3.5C20.0773 3.5 22.1667 5.58934 22.1667 8.16667C22.1667 10.744 20.0773 12.8333 17.5 12.8333C16.1062 12.8333 14.8551 12.2223 14 11.2535M17.5 24.5H3.5V23.3333C3.5 19.4673 6.63401 16.3333 10.5 16.3333C14.366 16.3333 17.5 19.4673 17.5 23.3333V24.5ZM17.5 24.5H24.5V23.3333C24.5 19.4673 21.366 16.3333 17.5 16.3333C16.225 16.3333 15.0296 16.6742 14 17.2698M15.1667 8.16667C15.1667 10.744 13.0773 12.8333 10.5 12.8333C7.92267 12.8333 5.83333 10.744 5.83333 8.16667C5.83333 5.58934 7.92267 3.5 10.5 3.5C13.0773 3.5 15.1667 5.58934 15.1667 8.16667Z"
                    stroke="#D1D5DB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="flex flex-col">
                  <span className="text-sm text-neutral-400">
                    Tempat Pengambilan
                  </span>
                  <span className="mt-1.5 text-lg font-semibold">
                    {transaction.transaction.pickUp.name || "test"}
                  </span>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <svg
                  className="w-8 h-8 text-neutral-300 dark:text-neutral-6000"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.33333 8.16667V3.5M18.6667 8.16667V3.5M8.16667 12.8333H19.8333M5.83333 24.5H22.1667C23.4553 24.5 24.5 23.4553 24.5 22.1667V8.16667C24.5 6.878 23.4553 5.83333 22.1667 5.83333H5.83333C4.54467 5.83333 3.5 6.878 3.5 8.16667V22.1667C3.5 23.4553 4.54467 24.5 5.83333 24.5Z"
                    stroke="#D1D5DB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="flex flex-col">
                  <span className="text-sm text-neutral-400">
                    Waktu Pengambilan
                  </span>
                  <span className="mt-1.5 text-lg font-semibold">
                    {moment(transaction.transaction.startDate).format("LL")} :{" "}
                    {transaction.transaction.startTime}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex-1 flex-col p-5 space-y-4">
              <div className="flex items-center space-x-4">
                <svg
                  className="w-8 h-8 text-neutral-300 dark:text-neutral-6000"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 5.07987C14.8551 4.11105 16.1062 3.5 17.5 3.5C20.0773 3.5 22.1667 5.58934 22.1667 8.16667C22.1667 10.744 20.0773 12.8333 17.5 12.8333C16.1062 12.8333 14.8551 12.2223 14 11.2535M17.5 24.5H3.5V23.3333C3.5 19.4673 6.63401 16.3333 10.5 16.3333C14.366 16.3333 17.5 19.4673 17.5 23.3333V24.5ZM17.5 24.5H24.5V23.3333C24.5 19.4673 21.366 16.3333 17.5 16.3333C16.225 16.3333 15.0296 16.6742 14 17.2698M15.1667 8.16667C15.1667 10.744 13.0773 12.8333 10.5 12.8333C7.92267 12.8333 5.83333 10.744 5.83333 8.16667C5.83333 5.58934 7.92267 3.5 10.5 3.5C13.0773 3.5 15.1667 5.58934 15.1667 8.16667Z"
                    stroke="#D1D5DB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="flex flex-col">
                  <span className="text-sm text-neutral-400">
                    Tempat Pengembalian
                  </span>
                  <span className="mt-1.5 text-lg font-semibold">
                    {transaction.transaction.dropOff.name || ""}
                  </span>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <svg
                  className="w-8 h-8 text-neutral-300 dark:text-neutral-6000"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.33333 8.16667V3.5M18.6667 8.16667V3.5M8.16667 12.8333H19.8333M5.83333 24.5H22.1667C23.4553 24.5 24.5 23.4553 24.5 22.1667V8.16667C24.5 6.878 23.4553 5.83333 22.1667 5.83333H5.83333C4.54467 5.83333 3.5 6.878 3.5 8.16667V22.1667C3.5 23.4553 4.54467 24.5 5.83333 24.5Z"
                    stroke="#D1D5DB"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="flex flex-col">
                  <span className="text-sm text-neutral-400">
                    Waktu Pengembalian
                  </span>
                  <span className="mt-1.5 text-lg font-semibold">
                    {moment(transaction.transaction.endDate).format("LL")} :{" "}
                    {transaction.transaction.endTime}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ------------------------ */}
        <div className="space-y-6">
          <h3 className="text-2xl font-semibold">Detail Transaksi</h3>
          <div className="flex flex-col space-y-4">
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Kode Transaksi</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {transaction.transaction._id}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Kurir</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {transaction.transaction.delivery}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Durasi Sewa</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {transaction.transaction.days} malam
              </span>
            </div>
            <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Biaya Sewa Barang (Per Malam)</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {formatRupiah(transaction.transaction.price, { prefix: "Rp " })}
              </span>
            </div>

            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Biaya Kurir</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {formatRupiah(
                  transaction.transaction.pickUp.price +
                    transaction.transaction.dropOff.price,
                  { prefix: "Rp. " }
                )}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Promo</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {formatRupiah(transaction.transaction.discount, {
                  prefix: "Rp. ",
                })}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Biaya Layanan</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {formatRupiah(3000, { prefix: "Rp. " })}
              </span>
            </div>
            <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>

            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1">Total</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {formatRupiah(transaction.transaction.total, {
                  prefix: "Rp. ",
                })}
              </span>
            </div>
          </div>
        </div>
        {renderWaiting()}
        <div>
          <ButtonPrimary href="/">Jelajahi barang lainnya</ButtonPrimary>
        </div>
      </div>
    );
  };

  const renderWaiting = () => {
    return (
      <div className="space-y-6">
        <h3 className="text-2xl font-semibold mb-3">Menunggu Konfirmasi</h3>
        <span>
          Vendor sudah mendapatkan informasi pesanan masuk, silahkan tunggu
          beberapa saat untuk konfirmasi dari vendor
        </span>
        <div>
          <span>Waktu tersisa: </span>
          <span>{secondToHour(countDown)}</span>
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-PayPage`} data-nc-id="PayPage">
      <main className="container mt-11 mb-24 lg:mb-32 ">
        <div className="max-w-4xl mx-auto">{renderContent()}</div>
      </main>
    </div>
  );
};

export default PayPage;
